// eslint-disable-next-line import/prefer-default-export
export const HOUR_FROM_TIME_OF_DAY = Object.freeze({
  morning: 6,
  afternoon: 12,
  evening: 17,
  night: 19,
  midNight: 0,
})
